import "../../styles/vars.scss";
import "../../styles/compo.scss";
import "../../styles/atoms.scss";
import React from "react";

const CopyLangP = () => {
  return (
    <div className="footer-box">
      <div className="copyright-box">© UUD 2026</div>
    </div>
  );
};

export default CopyLangP;



